




import { Component, Vue } from 'vue-property-decorator'
import { Route, NavigationGuardNext } from 'vue-router'
import ListaDeNovidades from '@/components/novidades/ListaDeNovidades.vue'
import { estadoDaLista } from '@/shareds/novidades/navegacao'

@Component({ components: { ListaDeNovidades } })
export default class TelaDeNovidades extends Vue {
	beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
		estadoDaLista.voltando = from.name === 'Novidade'
		next()
	}
}
